import { Box } from '@chakra-ui/react';
import { APIKongVX } from '@cyberkongz/api-interfaces';
import { CyberKongzGlViewer } from '@cyberkongz/vx-viewer';
import { useEffect, useRef } from 'react';

export function KongVXViewer({ kong }: { kong: APIKongVX }) {
  const { id } = kong;
  const vxContainer = useRef(null);

  useEffect(() => {
    const cyberKongzGlViewer = new CyberKongzGlViewer(vxContainer.current, {
      kong: {
        body: `https://cyberkongz.fra1.cdn.digitaloceanspaces.com/public/${id}/${id}.glb`,
        config: { kong },
        position: [0, 0],
        rotation: 5,
      },
      cameraPosition: [0, -0.15, 0],
      cameraZoom: 1,
      animation: 'Idle',

      zoomDisabled: true,
      parallaxDisabled: true,
      autoResize: true,
      rainDisabled: true,
      transparentBg: true,
      particlesDisabled: true,
    });

    return () => {
      cyberKongzGlViewer.destroy();
    };
  }, [id]);

  return (
    <Box
      ref={vxContainer}
      id={`vx-canvas-${id}`}
      css={{
        height: 'inherit',
        w: '100%',
        position: 'relative',
        zIndex: 1,
      }}
    />
  );
}
